export class FooterTextDataEN {
    static readonly htmlLabel = {
        privacyPolicy: 'Privacy Policy',
        poweredBy: 'Powered by Continual Engine',
    };
    static readonly snackbarLabels = {

    };
    static readonly tooltipLabels = {

    }
}
